import Controller from '@ember/controller';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { unprotectedRoutes } from 'scaleflow/routes/application';

export const HOMEPAGE = 'home';

export default class ApplicationController extends Controller {
  @service currentUser;
  @service notifications;
  @service session;
  @service roadmap;
  @service store;
  @service router;
  @service chatv2;
  @service betaToggle;

  queryParams = [
    {
      roadmap_id: {
        as: 'roadmap',
      },
    },
    'initiative_id',
  ];

  @tracked roadmap_id;
  @tracked initiative_id;
  @tracked state;

  get current_roadmap_id() {
    // eslint-disable-next-line ember/no-side-effects
    this.roadmap_id = this.roadmap.id;
    return '';
  }

  roadmapChanged() {
    this.roadmap_id = this.roadmap.id;
  }

  get pageIsArtifactViewMode() {
    return this.router.currentRoute.name === 'artifacts.artifact.view';
  }

  get isUnprotectedRoute() {
    return unprotectedRoutes.includes(this.router.currentRoute?.name);
  }
}
